import { Post } from '@/mocks/allPosts';
import { getPublishedPosts } from '@/utils/scheduler';

export interface SearchResult {
  post: Post;
  matchType: 'title' | 'tag' | 'excerpt' | 'content';
}

export function searchPosts(query: string, tagFilter?: string): Post[] {
  const published = getPublishedPosts();
  const q = query.trim().toLowerCase();

  if (!q && !tagFilter) return published;

  return published.filter((post) => {
    const matchesTag = tagFilter
      ? post.tags.some((t) => t.toLowerCase() === tagFilter.toLowerCase())
      : true;

    if (!q) return matchesTag;

    const matchesQuery =
      post.title.toLowerCase().includes(q) ||
      post.excerpt.toLowerCase().includes(q) ||
      post.tags.some((t) => t.toLowerCase().includes(q)) ||
      post.category.toLowerCase().includes(q) ||
      post.content.toLowerCase().includes(q);

    return matchesTag && matchesQuery;
  });
}

export function getAllTags(): string[] {
  const published = getPublishedPosts();
  const tagSet = new Set<string>();
  published.forEach((post) => post.tags.forEach((t) => tagSet.add(t)));
  return Array.from(tagSet).sort();
}

export function getSuggestions(query: string): string[] {
  if (!query.trim()) return [];
  const q = query.toLowerCase();
  const published = getPublishedPosts();
  const suggestions = new Set<string>();

  published.forEach((post) => {
    if (post.title.toLowerCase().includes(q)) suggestions.add(post.title);
    post.tags.forEach((t) => {
      if (t.toLowerCase().includes(q)) suggestions.add(t);
    });
  });

  return Array.from(suggestions).slice(0, 6);
}
